import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Event from "../../common/Event";
import LayoutHeader from "../../common/LayoutHeader";
import Footer from "../../common/LayoutFooter";
import PageLoader from "../../common/PageLoader";
import { sortEventsDesc } from "../../../utils/events";

const Events = () => {
  const [events, setEvents] = useState([]);
  const [filteredEvents, setFilteredEvents] = useState([]);
  const [cities, setCities] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeCityId, setActiveCityId] = useState(null);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/events?populate[address][populate][0]=city&populate[contact][populate]=*&populate[listImage][populate]=*&populate[detailsImage][populate]=*&populate[thumbnailImage][populate]=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        data?.data?.sort(sortEventsDesc);
        const list = data?.data || [];
        setEvents(list);
        setFilteredEvents(list);
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setIsLoading(false);
      }
    };

    const fetchCities = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/api/cities?populate=*`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${process.env.REACT_APP_API_TOKEN}`,
            },
          }
        );
        const data = await response.json();
        setCities(data?.data || []);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };

    fetchEvents();
    fetchCities();
  }, []);

  const scrollTop = () => window.scrollTo({ top: 0, behavior: "smooth" });
  const base = process.env.PUBLIC_URL || "";

  const filterByCity = (cityId) => {
    setActiveCityId(cityId);
    if (cityId == null) {
      setFilteredEvents(events);
      return;
    }
    setFilteredEvents(
      events.filter(
        (ev) => ev?.attributes?.address?.city?.data?.id === cityId
      )
    );
  };

  if (isLoading) {
    return (
      <>
        <LayoutHeader />
        <PageLoader />
      </>
    );
  }

  return (
    <div className="hypena-page-wrap">
      <LayoutHeader />
      <div className="hn-breadcrumb">
        <h1>Events</h1>
        <nav className="hn-breadcrumb-nav">
          <Link to={`${base}/`} onClick={scrollTop}>Home</Link>
          <i className="bi bi-chevron-right" />
          <span>Events</span>
        </nav>
      </div>
      <section className="hn-section">
        {cities?.length > 0 && (
          <div className="hn-pills">
            <button
              type="button"
              className={`hn-pill ${activeCityId == null ? "active" : ""}`}
              onClick={() => filterByCity(null)}
            >
              All <span>({events.length})</span>
            </button>
            {cities.map((city) => {
              const count = events.filter(
                (ev) => ev?.attributes?.address?.city?.data?.id === city.id
              ).length;
              return (
                <button
                  key={city.id}
                  type="button"
                  className={`hn-pill ${activeCityId === city.id ? "active" : ""}`}
                  onClick={() => filterByCity(city.id)}
                >
                  {city?.attributes?.name} <span>({count})</span>
                </button>
              );
            })}
          </div>
        )}
        {filteredEvents.length > 0 ? (
          <div className="hn-cards">
            {filteredEvents.map((event) => (
              <Event key={event.id} eventData={event} />
            ))}
          </div>
        ) : (
          <p style={{ color: "var(--hn-gray5)", textAlign: "center" }}>
            No events in this category.
          </p>
        )}
      </section>
      <Footer />
    </div>
  );
};

export default Events;
